import { v4 as uuidv4 } from 'uuid'
import { z } from 'zod'

import { Mode } from 'theme/constants'
const { localStorage } = window

enum Storage {
  basePrefix = 'AP_BASE_PWA',
  language = 'LANGUAGE',
  versionSuffix = 'BUNDLE_VERSION',
  deviceID = 'DEVICE_ID',
  adminMode = 'ADMIN_MODE',
  themeVariant = 'THEME_VARIANT',
}

export const storageDefaults = {
  language: 'en',
  adminMode: false,
  theme: Mode.DARK,
}

export const LanguageChange = new Event('language-change')
export const AdminModeChange = new Event('admin-mode-change')

export const setBundleVersion = (version: string): void =>
  localStorage.setItem(
    `${Storage.basePrefix}_${Storage.versionSuffix}`,
    version,
  )
export const getBundleVersion = (): string | null =>
  localStorage.getItem(`${Storage.basePrefix}_${Storage.versionSuffix}`)

export const setLanguage = (language: string): void => {
  localStorage.setItem(`${Storage.basePrefix}_${Storage.language}`, language)
  document.dispatchEvent(LanguageChange)
}
export const getLanguage = (): string | null =>
  localStorage.getItem(`${Storage.basePrefix}_${Storage.language}`)

export const setDeviceID = (): void => {
  if (!localStorage.getItem(`${Storage.basePrefix}_${Storage.deviceID}`)) {
    const uuid = uuidv4()
    localStorage.setItem(`${Storage.basePrefix}_${Storage.deviceID}`, uuid)
  }
}
export const getDeviceID = (): string | null =>
  localStorage.getItem(`${Storage.basePrefix}_${Storage.deviceID}`)

export const getAdminMode = (): boolean => {
  const adminMode = localStorage.getItem(
    `${Storage.basePrefix}_${Storage.adminMode}`,
  )
  return adminMode !== null ? adminMode === 'true' : storageDefaults.adminMode
}
export const setAdminMode = (adminMode: boolean): void => {
  localStorage.setItem(
    `${Storage.basePrefix}_${Storage.adminMode}`,
    JSON.stringify(adminMode),
  )
  document.dispatchEvent(AdminModeChange)
}

export const setThemeVariant = (theme: Mode | null): void => {
  if (theme !== null) {
    localStorage.setItem(`${Storage.basePrefix}_${Storage.themeVariant}`, theme)
  } else {
    localStorage.removeItem(`${Storage.basePrefix}_${Storage.themeVariant}`)
  }
}

const THEME_VARIANT_SCHEMA = z.nativeEnum(Mode).nullable()

export const getThemeVariant = (): Mode | null => {
  const value = THEME_VARIANT_SCHEMA.safeParse(
    localStorage.getItem(`${Storage.basePrefix}_${Storage.themeVariant}`),
  )
  // console.log(
  //   'getThemeVariant',
  //   value,
  //   localStorage.getItem(`${Storage.basePrefix}_${Storage.themeVariant}`)
  // )
  if (value.success) return value.data
  return null
}
